module.exports = __webpack_public_path__ + "static/media/flsa_export.9da9996c.svg";